import React from 'react';
import { connect } from 'react-redux';
import { isVisible as cookieInfoIsVisible } from 'src/utils/cookieBanner';
import SiteBar from 'src/components/siteBar/siteBar';
import Footer from 'src/components/footer';
import Alert from 'src/modules/shared/alert/components/alert';
import head from 'src/utils/head';
import stylesheet from 'styles/layouts/default.scss';
import { updateLanguage } from 'src/modules/shared/context/actions';
import { unsetAlert } from 'src/modules/shared/alert/actions';
import classNames from 'classnames';
import VerificationBar from 'src/components/verificationBar';
import CookieInfoBanner from 'src/components/cookieInfoBanner';
const isServer = typeof window === 'undefined';

const DefaultLayout = (props) => {
    const { alert, children, showVerificationBar, fullWidth, modal, seo, siteContainerClassName, currentUser, updateLanguage, unsetAlert, siteBar } = props;
    const lang = 'en';
    const pageContainerClassNames = classNames({
      'page-container': !fullWidth,
      'full-width-page-container': fullWidth,
      'page-default': true,
      'content-top-margin': !showVerificationBar,
      'content-top-margin--with-verification' : showVerificationBar,
    });

    const huSiteBar = !!siteBar
      ? siteBar
      : <SiteBar lang={lang} />;

    return (
      <div>
        {head(seo, props.head)}
        <style dangerouslySetInnerHTML={{ __html: stylesheet }} />
        <div className={siteContainerClassName}>
          {huSiteBar}
          {currentUser && showVerificationBar && <VerificationBar />}
          {alert && (
            <Alert
              global={alert.global}
              type={alert.type}
              onFinished={unsetAlert}
            >
              {alert.message}
            </Alert>
          )}
          {!isServer && cookieInfoIsVisible() && <CookieInfoBanner />}
          <div className={pageContainerClassNames}>
            {children}
          </div>
          {modal}
        </div>
        <Footer
          isLoggedIn={!!currentUser}
          lang={lang}
          updateLanguage={updateLanguage}
        />
      </div>
  );
};

DefaultLayout.defaultProps = {
  seo: {},
  fullWidth: false,
};

export function mapStateToProps(state) {
  return {
    alert: state.alert.alert,
    modal: state.modal.modal,
    currentUser: state.context.currentUser,
    isLoggedIn: !!state.context.currentUser,
    showVerificationBar: state.context.showVerificationBar,
  };
}

export default connect(mapStateToProps, { updateLanguage, unsetAlert })(DefaultLayout);



// WEBPACK FOOTER //
// ./src/layouts/default.js